import { Button, Form, Input, Switch } from 'antd'
import { useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import { numberWithCommas } from 'utils'
import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons'
import { NumericFormat } from 'react-number-format'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  .content-list {
    display: flex;
    flex-direction: column;
    gap: 4px;

    li {
      font-size: 14px;

      span {
        font-weight: 700;
      }
    }
  }

  .custom-label {
    .ant-form-item-label {
      overflow: visible;
      margin-bottom: 6px;
    }
  }
`

const ConfirmForm = ({
  form,
  packageSelected,
  qty,
  productPriceDefault,
  dataDetail,
}: {
  form: any
  packageSelected: any
  qty: number
  productPriceDefault?: any
  dataDetail?: any
}) => {
  const [isConfirm, setIsConfirm] = useState<boolean>(true)
  const [productPrice, setProductPrice] = useState<number | string>(0)
  const [msgProductPrice, setMsgProductPrice] = useState<string>("")
  const [insuranceFee, setInsuranceFee] = useState<number>(0)
  const [viewMore, setViewMore] = useState<boolean>(false)

  const handleChagneConfirm = useCallback((e) => {
    setIsConfirm(e)
  }, [])

  const handleChagneProductPrice = (value) => {
    setProductPrice(+value)
    if (+value > packageSelected?.insurance * qty) {
      const fee = +value * (packageSelected?.fee_insurance / 100)
      setInsuranceFee(parseInt(fee.toFixed(0)))
    } else {
      setInsuranceFee(0)
    }
  }
  useEffect(() => {
    handleChagneProductPrice(productPrice);
  },[packageSelected?.fee_insurance]);

  useEffect(() => {
    if (productPriceDefault) {
      setProductPrice(productPriceDefault)
      form.setFieldValue('productPrice', productPriceDefault)
    }

    if (dataDetail && dataDetail?.product_price) {
      setIsConfirm(true)
    }
  }, [dataDetail, productPriceDefault, form])

  return (
    <Wrapper>
      <ul className='content-list'>
        <li>
          Miễn phí - Bảo hiểm mất mát tối đa <span>{numberWithCommas(packageSelected?.insurance)}đ</span>/1 kiện hàng.(Không tính
          trường hợp bị kiểm tra VAT bởi CQCN/QLTT)
        </li>

        {viewMore && (
          <>
            <li>
              Khách hàng mua bảo đảm hàng hóa sẽ được bồi thường tối đa 100% giá trị khai giá khi bị mất hàng, hư hỏng do lỗi vận
              chuyển.
            </li>
            <li>
              <span>ToanQuocPost.VN</span> chỉ nhận khai giá tối đa{' '}
              <span>{numberWithCommas(packageSelected?.max_product_price)}đ</span>/1 kiện hàng
            </li>
            <li>Quý khách không mua bảo đảm vui lòng không click chọn mục này để tránh bị tính phí bảo đảm hàng hóa.</li>
          </>
        )}

        <li style={{ listStyleType: 'none', textAlign: 'center' }}>
          <Button onClick={() => setViewMore((prev) => !prev)}>
            {viewMore ? (
              <>
                <ArrowUpOutlined /> Rút gọn
              </>
            ) : (
              <>
                <ArrowDownOutlined /> Xem thêm
              </>
            )}
          </Button>
        </li>
      </ul>

      <Form form={form} layout='horizontal'>
        <div className='custom-label'>
          <Form.Item label={`Mua bảo đảm, phí bảo đảm là ${packageSelected?.fee_insurance}% khai giá hàng hóa`} name='isConfirm'>
            <Switch onChange={handleChagneConfirm} checked={isConfirm} disabled />
          </Form.Item>
        </div>

        {isConfirm && (
          <>
            <Form.Item
              label='Khai giá hàng hóa'
              name='productPrice'
              rules={[
                {
                  validator(_, value) {
                    if (+productPrice > 0 && +productPrice <= (packageSelected?.max_product_price * qty)) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error(`Khai giá hàng hóa phải lớn hơn 0 và phải nhỏ hơn hoặc bằng ${numberWithCommas(packageSelected?.max_product_price * qty)}đ`));
                  },
                },
              ]}
              labelCol={{ span: 5, md: { span: 4 }, lg: { span: 4 }, xxl: { span: 3 } }}
              wrapperCol={{ span: 20, lg: { span: 20 }, xxl: { span: 21 } }}
            >
              <NumericFormat
                className='number-format'
                allowLeadingZeros
                thousandSeparator=','
                value={productPrice}
                onValueChange={(e) => {
                  form.setFieldValue('productPrice', e?.floatValue)
                  handleChagneProductPrice(e?.floatValue)
                }}
                onFocus={(e) => {
                  if (e?.target?.value == '0' || +e?.target?.value === 0) {
                    setProductPrice('')
                  }
                }}
                onBlur={(e) => {
                  if (e?.target?.value == '') {
                    setProductPrice(0)
                  }
                }}
                isAllowed={(values: any) => {
                  const { floatValue } = values
                  if (floatValue) {
                    return floatValue <= 999999999999
                  }
                  return true
                }}
                defaultValue={productPrice}
                placeholder='Nhập khai giá hàng hóa'
              />
              <p>{msgProductPrice}</p>
            </Form.Item>
            <Form.Item label='Phí bảo hiểm'
              labelCol={{ span: 5, md: { span: 4 }, lg: { span: 4 }, xxl: { span: 3 } }}
              wrapperCol={{ span: 20, lg: { span: 20 }, xxl: { span: 21 } }}>
              <Input disabled value={numberWithCommas(insuranceFee)} />
            </Form.Item>
          </>
        )}
      </Form>
    </Wrapper>
  )
}

export default ConfirmForm
